module.exports = __webpack_public_path__ + "img/product_headimg.8298cb85.png";